import React, { useState } from 'react';
import './Header.css';

const Header = () => {
  const [mobileNavActive, setMobileNavActive] = useState(false);

  const toggleMobileNav = () => {
    setMobileNavActive(!mobileNavActive);
  };

  // Navigation items with their indices for staggered animation
  const navItems = [
    { href: "#home", text: "Home", index: 1 },
    { href: "#chat", text: "Chat", index: 2 },
    { href: "#about", text: "About", index: 3 },
    { href: "#research", text: "Research", index: 4 },
    { href: "#applications", text: "Applications", index: 5 },
    { href: "#contact", text: "Contact", index: 6 },
    { href: "#login", text: "Login (Coming Soon!)", index: 7 }
  ];

  return (
    <header className={`header ${mobileNavActive ? 'mobile-nav-active' : ''}`}>
      <div className="container">
        <div className="logo">
          <a href="/"><span className="ai-gradient-text">NightHawk AI</span></a>
        </div>
        <nav className="nav">
          <ul>
            {navItems.map((item) => (
              <li key={item.index} style={{"--item-index": item.index}}>
                <a href={item.href}>{item.text}</a>
              </li>
            ))}
          </ul>
        </nav>
        <div className="menu-toggle" onClick={toggleMobileNav}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </header>
  );
};

export default Header;